import { render, staticRenderFns } from "./professionalIdentification.view.vue?vue&type=template&id=21ce7bb3"
import script from "./professionalIdentification.view.vue?vue&type=script&lang=js"
export * from "./professionalIdentification.view.vue?vue&type=script&lang=js"
import style0 from "./professionalIdentification.view.vue?vue&type=style&index=0&id=21ce7bb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports